import React, { lazy } from "react";
import { defer } from "react-router-dom";
import RouteLoader from "../UI/RouteLoader";
import { getCourseRequest } from "../../requests/courses";
import { withSuspense } from "./routeHelpers";

const Courses = lazy(
  () => import(/* webpackChunkName: "courses" */ "../Courses/Courses")
);
const Course = lazy(
  () => import(/* webpackChunkName: "courses" */ "../Courses/Course/Course")
);
const CourseOverview = lazy(
  () =>
    import(
      /* webpackChunkName: "courses" */ "../Courses/Course/CourseOverview/CourseOverview"
    )
);
const CourseLessons = lazy(
  () =>
    import(
      /* webpackChunkName: "courses" */ "../Courses/Course/CourseLessons/CourseLessons"
    )
);
const CourseDecisions = lazy(
  () =>
    import(
      /* webpackChunkName: "courses" */ "../Courses/Course/CourseDecisions/CourseDecisions"
    )
);
const CourseProducts = lazy(
  () =>
    import(
      /* webpackChunkName: "courses" */ "../Courses/Course/CourseProducts/CourseProducts"
    )
);
const CourseNew = lazy(
  () => import(/* webpackChunkName: "courses" */ "../Courses/Course/CourseNew")
);
const CourseSchools = lazy(
  () =>
    import(
      /* webpackChunkName: "courses" */ "../Courses/Course/CourseSchools/CourseSchools"
    )
);

export default [
  {
    path: "/courses",
    element: withSuspense(Courses),
  },
  {
    path: "/courses/new",
    element: withSuspense(CourseNew),
  },
  {
    path: "/courses/:courseId",
    element: (
      <RouteLoader>
        {(loader) => withSuspense(<Course course={loader?.data} />)}
      </RouteLoader>
    ),
    id: "course",
    loader: ({ params }) => {
      return defer({
        data: getCourseRequest({ courseId: params.courseId }),
      });
    },
    children: [
      {
        path: "/courses/:courseId/overview",
        element: withSuspense(CourseOverview),
      },
      {
        path: "/courses/:courseId/lessons",
        element: withSuspense(CourseLessons),
      },
      {
        path: "/courses/:courseId/decisions",
        element: withSuspense(CourseDecisions),
      },
      {
        path: "/courses/:courseId/products",
        element: withSuspense(CourseProducts),
      },
      {
        path: "/courses/:courseId/schools",
        element: withSuspense(CourseSchools),
      },
    ],
  },
];
